import { render, staticRenderFns } from "./FactoringContractListItem.vue?vue&type=template&id=4ed1f6d6&lang=pug&"
import script from "./FactoringContractListItem.vue?vue&type=script&lang=js&"
export * from "./FactoringContractListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports